import * as React from 'react';
import { PictureRef } from "../../@types/cms/PictureRef";

export type ImageProps = {
    pictureRef?: PictureRef;
    imageSrc?: string;
    sizes?: string;
    srcSet?: string;
    className?: string | string[];
    minWidth?: number;
    maxWidth?: number;
    steps?: number;
    alt?: string;
    // includeRatio?: boolean;
    onLoad?: () => void;
    onError?: () => void;
}

export class Image extends React.Component<ImageProps> {
    public render() {
        const classnames = this._GetClassName();
        const maxWidth = this.props.maxWidth || 4000;
        const minWidth = this.props.minWidth || 200;
        let steps = (this.props.steps || 8);
        const stepSize = (maxWidth - minWidth) / steps;
        const alt = this.props.alt || '';
        const sizes = this.props.sizes || '100vw';
        const width = this.props.pictureRef && this.props.pictureRef.Width || 0;
        const imageSrc = this.props.pictureRef && this.props.pictureRef.Src || this.props.imageSrc || '';

        const srcSet: string[] = [];
        steps++;

        while (steps--) {
            const w = stepSize * steps + minWidth;
            if (width && w > width) { continue; }
            const src = `${imageSrc}?width=${w} ${w}w`;
            srcSet.push(src);
        }

        const atts: React.ImgHTMLAttributes<HTMLImageElement> = {
            alt,
            className: classnames.join(' '),
            sizes,
            src: `${imageSrc}`,
            srcSet: srcSet.join(', ') || ''
        };

        if (this.props.onLoad) {
            atts.onLoad = this.props.onLoad;
        }

        if (this.props.onError) {
            atts.onError = this.props.onError;
        }

        return (
            <img
                {...atts}
            />);

    }

    private _GetClassName(): string[] {

        if (!this.props.className) { return []; }

        if (typeof this.props.className === 'string') { return [this.props.className]; }

        if (typeof this.props.className === 'object') { return [...this.props.className]; }

        return [];
    }
}

export default Image;


// WEBPACK FOOTER //
// ./src/Components/Image/Image.tsx